import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/contexts/AuthContext";
import { openAuth } from "@/lib/guestGate";
import { LogIn } from "lucide-react";

// Persistent, always-visible sign-up/log-in CTA for guests (mirrors the discussion FAB).
export default function GuestAuthPill() {
  const { user, loading } = useAuth();

  return (
    <AnimatePresence>
      {!loading && !user && (
        <motion.button
          initial={{ opacity: 0, y: 24, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 300, damping: 22, delay: 0.5 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={openAuth}
          className="fv-gradient fixed left-4 bottom-[4.5rem] lg:left-6 lg:bottom-6 z-[55] inline-flex items-center gap-2 pl-4 pr-5 py-3 rounded-full text-white font-semibold text-sm shadow-lg shadow-view-a/30 hover:shadow-view-a/50 transition-shadow"
          data-testid="guest-auth-pill"
        >
          <LogIn className="w-4 h-4" /> Sign up / Log in
        </motion.button>
      )}
    </AnimatePresence>
  );
}
